import React from "react"

import { Button, Flex, Link, Wrapper } from "components"

const ButtonBlock = ({ text, link }) => (
  <Wrapper maxWidth={768}>
    <Flex justifyContent="center">
      <Button
        as={Link}
        children={text}
        to={link}
        intent="default"
        appearance="default"
        width="100%"
        maxWidth={360}
      />
    </Flex>
  </Wrapper>
)

export default ButtonBlock
